// ── 통합 계약 화면: 콜 없이 직접 등록할 때 '등록할 회사' 고르기 (2026-10-15, 4단계 계약 통합 4-5) ─────────
//   통합 메뉴는 여러 회사 계약을 함께 보므로, 콜 없이 새로 등록하는 계약은 어느 회사 것인지 꼭 고른다
//   (사용자 결정 2026-10-14 1-a — 처음엔 비어 있음, 서버도 메뉴 회사인지 다시 본다).
//   콜에서 온 계약(콜 계약 등록·콜에 붙는 재주문)은 콜의 회사를 따라가므로 이 줄이 뜨지 않는다(ContractModal).
//   모양은 통합 일일콜의 회사 고르기(tm/callregister/CallCompanyPicker)와 같다.
import React from 'react';
import { companyColor } from '../integratedmenu/integratedFeatureMeta';
// 단추 글자 = 작업 대상과 같은 회사 이름(2026-10-15). 고르는 값은 그대로 코드
import { useCompanyNames } from '../adminlayout/useCompanyNames';

const rowStyle = (isMobile, error) => ({
  display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
  padding: isMobile ? '10px 12px' : '10px 14px', marginBottom: 12,
  border: `1px solid ${error ? '#ef4444' : 'var(--border)'}`, borderRadius: 10,
  background: error ? 'rgba(239,68,68,0.08)' : 'var(--bg-card)',
});
const labelStyle = { fontSize: 13, fontWeight: 800, color: 'var(--text)', marginRight: 4 };
const hintStyle = { fontSize: 12, color: '#dc2626', fontWeight: 600 };
const noteStyle = { fontSize: 12, color: 'var(--text-muted)' };
const btnStyle = (on, code) => {
  const c = companyColor(code);
  return {
    height: 32, padding: '0 14px', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 700,
    border: `1.5px solid ${on ? c.bg : 'var(--border)'}`,
    background: on ? c.bg : 'var(--bg-card)', color: on ? c.fg : 'var(--text-sub)',
  };
};

/**
 * @param {string[]} props.companies  메뉴 회사 코드들
 * @param {string}   props.value      고른 회사('' = 아직 안 고름)
 * @param {(code:string)=>void} props.onChange
 * @param {boolean}  props.error      저장을 눌렀는데 안 골랐을 때
 */
// label·doneNote·needNote: 홍보물 통합 화면도 같이 쓴다(2026-10-19 5-6). 기본값은 계약 그대로.
export function ContractCompanyPicker({
  companies, value, onChange, isMobile, error = false,
  label = '등록할 회사', doneNote = '고른 회사의 계약으로 저장됩니다.', needNote = '회사를 골라야 등록할 수 있습니다.',
}) {
  const nameOf = useCompanyNames();
  return (
    <div style={rowStyle(isMobile, error)}>
      <span style={labelStyle}>{label}</span>
      {companies.map((code) => (
        <button key={code} type="button" style={btnStyle(value === code, code)}
          aria-pressed={value === code} onClick={() => onChange(code)}>
          {nameOf(code)}
        </button>
      ))}
      {value
        ? <span style={noteStyle}>{doneNote}</span>
        : <span style={hintStyle}>{needNote}</span>}
    </div>
  );
}
